import * as yup from "yup";

const digitsOnly = (value) =>
  /^\d*[\{1}\d*]\d*$/.test(value) || value?.length === 0;

export const preCibilValidator = yup.object().shape({
  // company_name: yup.string().required("Please select company name."),
  // cibil_rank: yup
  //   .number()
  //   .required("Please enter Cibil rank.")
  //   .typeError("Please enter a valid Cibil rank."),
  //   turnover: yup
  //   .number()
  //   .required("Please enter turnover.")
  //   .typeError("Please enter a valid turnover."),
  //   total_debt: yup
  //   .number()
  //   .required("Please enter total debt.")
  //   .typeError("Please enter a valid total debt."),
  //   operating_profits: yup
  //   .number()
  //   .required("Please enter operating profits.")
  //   .typeError("Please enter a valid operating profits."),
  //   networth: yup
  //   .number()
  //   .required("Please enter networth.")
  //   .typeError("Please enter a valid networth."),
  // loanterm: yup
  //   .string()
  //   .required("Please enter tenure.")
  //   .typeError("Please enter a valid tenure.")
  //   .test("loanterm", "The field should have digits only", digitsOnly)
  //   .min(1),
  // rate_of_interest: yup
  //   .string()
  //   .trim()
  //   .required("Please enter rate of interest.")
  //   .typeError("Please enter a valid rate of interest.")
  //   .test("rate_of_interest", "The field should have digits only", digitsOnly)
  //   .min(1),
  // loan_purpose: yup.string().required("Please enter loan purpose."),
  // total_bank_balance: yup
  //   .number()
  //   .required("Please enter total bank balance.")
  //   .typeError("Please enter a valid total bank balance."),
  //   total_current_assets: yup
  //   .number()
  //   .required("Please enter total current assets.")
  //   .typeError("Please enter a valid total current assets."),
  //   total_fixed_assets: yup
  //   .number()
  //   .required("Please enter total fixed assets.")
  //   .typeError("Please enter a valid total fixed assets."),
  //   total_assets: yup
  //   .number()
  //   .required("Please enter total assets.")
  //   .typeError("Please enter a valid total assets."),
  //   total_current_liabilities: yup
  //   .number()
  //   .required("Please enter total current liabilities.")
  //   .typeError("Please enter a valid total current liabilities."),
  //   total_fixed_liabilities: yup
  //   .number()
  //   .required("Please enter total fixed liabilities.")
  //   .typeError("Please enter a valid total fixed liabilities."),
  //   total_liabilities: yup
  //   .number()
  //   .required("Please enter total liabilities.")
  //   .typeError("Please enter a valid total liabilities."),
  //   total_equity: yup
  //   .number()
  //   .required("Please enter total equity.")
  //   .typeError("Please enter a valid total equity."),
  //   total_revenue: yup
  //   .number()
  //   .required("Please enter total revenue.")
  //   .typeError("Please enter a valid total revenue."),
  //   total_cost_of_sales: yup
  //   .number()
  //   .required("Please enter total cost of sales.")
  //   .typeError("Please enter a valid total cost of sales."),
  //   total_operating_expenses: yup
  //   .number()
  //   .required("Please enter total operating expenses.")
  //   .typeError("Please enter a valid total operating expenses."),
  //   total_other_income: yup
  //   .number()
  //   .required("Please enter total other income.")
  //   .typeError("Please enter a valid total other income."),
  //   total_other_expenses: yup
  //   .number()
  //   .required("Please enter total other expenses.")
  //   .typeError("Please enter a valid total other expenses."),
  //   total_gross_profit: yup
  //   .number()
  //   .required("Please enter total gross profit.")
  //   .typeError("Please enter a valid total gross profit."),
  //   total_income: yup
  //   .number()
  //   .required("Please enter total income.")
  //   .typeError("Please enter a valid total income."),
  //   total_expenses: yup
  //   .number()
  //   .required("Please enter total expenses.")
  //   .typeError("Please enter a valid total expenses."),
});
